import { useState, useEffect } from 'react';
import { CURRENCIES, DATE_FORMATS, formatCurrency } from '../utils/currencyData';
import useSettings from './useSettings';
import moment from 'moment';

const useFormattingSettings = () => {
  const [currency, setCurrency] = useState('BRL');
  const [dateFormat, setDateFormat] = useState('DD/MM/YYYY');
  const [loading, setLoading] = useState(true);
  
  const { getAll, update } = useSettings();
  
  // Carregar configurações ao inicializar
  useEffect(() => {
    const loadSettings = async () => {
      try {
        const settings = await getAll();
        
        // Buscar configurações de currency e data format
        const currencySetting = settings?.find(s => s.key === 'systemCurrency');
        const dateFormatSetting = settings?.find(s => s.key === 'systemDateFormat');
        
        if (currencySetting?.value) {
          setCurrency(currencySetting.value);
        }
        
        if (dateFormatSetting?.value) {
          setDateFormat(dateFormatSetting.value);
        }
      } catch (error) {
        console.error('Erro ao carregar configurações de formatação:', error);
      } finally {
        setLoading(false);
      }
    };
    
    loadSettings();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  
  // Função para atualizar currency
  const updateCurrency = async (newCurrency) => {
    try {
      await update({
        key: 'systemCurrency',
        value: newCurrency
      });
      setCurrency(newCurrency);
      return true;
    } catch (error) {
      console.error('Erro ao atualizar currency:', error);
      return false;
    }
  };
  
  // Função para atualizar formato de data
  const updateDateFormat = async (newFormat) => {
    try {
      await update({
        key: 'systemDateFormat', 
        value: newFormat
      });
      setDateFormat(newFormat);
      return true;
    } catch (error) {
      console.error('Erro ao atualizar formato de data:', error);
      return false;
    }
  };
  
  // Função para formatar valor monetário com a currency atual
  const formatValue = (amount, showSymbol = true) => {
    return formatCurrency(amount, currency, showSymbol);
  };
  
  // Função para formatar data com o formato atual
  const formatDate = (date, customFormat = null) => {
    const format = customFormat || dateFormat;
    return moment(date).format(format);
  };
  
  // Função para obter informações da currency atual
  const getCurrentCurrency = () => {
    return CURRENCIES[currency] || CURRENCIES.BRL;
  };
  
  // Função para obter informações do formato de data atual
  const getCurrentDateFormat = () => {
    return DATE_FORMATS[dateFormat] || DATE_FORMATS['DD/MM/YYYY'];
  };
  
  return {
    currency,
    dateFormat,
    loading,
    updateCurrency,
    updateDateFormat,
    formatValue,
    formatDate,
    getCurrentCurrency,
    getCurrentDateFormat,
    CURRENCIES,
    DATE_FORMATS
  };
};

export default useFormattingSettings;